import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { PlacementType } from '@epicuro-next/ataraxia/dropdown';
import { dynamicElementsDropdown } from '@epicuro-next/constants/dynamic-elements';
import { dispatchDynamicEvent } from '@epicuro-next/platform/dynamic-actions';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';

import {
  IDynamicDropdownItem,
  IDynamicDropdownItemConfig,
} from '../models/dynamic-dropdown-item.interface';

@DynamicComponentRegister(dynamicElementsDropdown, true)
@Component({
  selector: 'epc-dynamic-elements-dropdown',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dynamic-elements-dropdown.component.html',
  styleUrls: ['./dynamic-elements-dropdown.component.scss'],
  standalone: false,
})
export class DynamicElementsDropdownComponent {
  @Input()
  public text: string | null = null;

  @Input()
  public icon: string[] | null = null;

  @Input()
  public iconConfig: { placement: 'prefix' | 'suffix' } = {
    placement: 'prefix',
  };

  @Input()
  public dropdownItems: IDynamicDropdownItem[] = [];

  @Input()
  public trigger: 'click' | 'hover' = 'click';

  @Input()
  public clickHide = true;

  @Input()
  public disabled = false;

  @Input()
  public placement: PlacementType = 'bottomCenter';

  @Output() public selectionChanged = new EventEmitter<IDynamicDropdownItem>();

  public onClick(item: IDynamicDropdownItem) {
    this.selectionChanged.emit(item);
    const actionPropertyName: keyof IDynamicDropdownItemConfig = 'action';

    let action: string | { type: string; value: unknown } | undefined;
    if (item.config !== undefined && actionPropertyName in item.config) {
      action = item.config[actionPropertyName];
    }

    if (!action) {
      return;
    }

    if (typeof action === 'string') {
      dispatchDynamicEvent(action);

      return;
    }

    try {
      const { type, value } = action;

      dispatchDynamicEvent(type, value);
    } catch {
      throw new Error(
        `Failed to parse dynamic action ${JSON.stringify(action)}`,
      );
    }
  }
}
